import React, { useRef } from 'react';

const Citizenship = ({i, formData, setFormData}) => {

    const proof = [
        {name: 'proof_01', value: 'Permanent Resident Card (`Green Card`, I-551)'},
        {name: 'proof_02', value: 'Certificate of Naturalization'},
        {name: 'proof_03', value: 'Temporary I-551 Stamp (on passport or I-94, I-94A'},
        {name: 'proof_04', value: 'Reentry Permit (I-327)'},
        {name: 'proof_05', value: 'Machine Readable Immigrant Visa (W/ temporary I-551 language)'},
        {name: 'proof_06', value: 'Employment Authorization Card (EAS I-766)'},
        {name: 'proof_07', value: 'Arrival/Departure Record (I-94, I-94A)'},
        {name: 'proof_08', value: 'Arrival/Departure Record in unexpired foreign passport'},
        {name: 'proof_09', value: 'Refugee Travel Document (I-571)'},
        {name: 'proof_10', value: 'Certificate if Eligibility for Nonimmigrant (F-1) Student Status (I-20)'},
        {name: 'proof_11', value: 'Certificate if Eligibility for Exchange Visitor (J-1) Status (DS2019)'},
        {name: 'proof_12', value: 'Notice of action (I-797)'},
        {name: 'proof_13', value: 'Unexpired foreign passport'},
        {name: 'proof_14', value: 'Other document with an Alien Number or I-94 Number'},
        {name: 'proof_15', value: 'Members of a federally recognized indian tribe'},
        {name: 'proof_16', value: 'Certification from U.S. Department of Health and Human Services (HHS) Office of Refugee Resettlement (ORR)'},
        {name: 'proof_17', value: 'Office of Refugee Resettlement (ORR) eligibility letter (if under 18)'},
        {name: 'proof_18', value: 'Cuban/Haitian Entrant'},
        {name: 'proof_19', value: 'Non Citizen Who Is Lawfully Present In American Samoa'},
        {name: 'proof_20', value: 'Battered spouse, child, or parent under the Violence Against Women Act'},
        {name: 'proof_21', value: 'Another document or alien number/I-94 number'},
        {name: 'proof_22', value: 'None of these (Select this if this person doesn\'t have a listed document. You can continue the application without selecting a document or status type.)'},
    ];

    const applicantCitizenStatus = i === 0 ? 'citizen_status' : 'applicant_' + i + '_citizen_status';
    const applicantCitizenStatusProof = i === 0 ? 'citizen_status_proof' : 'applicant_' + i + '_citizen_status_proof';
    const applicantCitizenStatusProofId = i === 0 ? 'citizen_status_proof_id' : 'applicant_' + i + '_citizen_status_proof_id';
    const applicantName = i === 0 ? 'applicant_name' : 'applicant_' + i + '_name';

    const proofRef = useRef(null);

    const handleCitizenStatus = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
        if (value !== 'Naturalized Citizen' && value !== 'Derived Citizen' && value !== 'Eligible Immigrant') {
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCitizenStatusProof]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCitizenStatusProofId]: '' }));
        }
    };
    const handleProof = () => {
        const checkedBoxes = proofRef.current.querySelectorAll('input[type="checkbox"]:checked');
        const checkedBoxesValues = Array.from(checkedBoxes).map(cb => cb.value).join(',');
        const checkedBoxesDescriptions = Array.from(checkedBoxes).map(cb => proof.find(p => p.name === cb.value).value).join(',');

        setFormData((prevFormData) => ({ ...prevFormData, [applicantCitizenStatusProofId]: checkedBoxesValues }));
        setFormData((prevFormData) => ({ ...prevFormData, [applicantCitizenStatusProof]: checkedBoxesDescriptions }));
    };

    return (
        <div>
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor={applicantCitizenStatus}>{formData[applicantName].split(' ')[0]} is a:</label>
                <select className="QuestionInput" id={applicantCitizenStatus} name={applicantCitizenStatus} value={formData[applicantCitizenStatus]} onChange={handleCitizenStatus}>
                    <option value="US Citizen or US National">US Citizen or US National</option>
                    <option value="Naturalized Citizen">Naturalized Citizen</option>
                    <option value="Derived Citizen">Derived Citizen</option>
                    <option value="Eligible Immigrant">Eligible Immigrant</option>
                    <option value="Other">Other</option>
                </select>
            </div>
            <div className="QuestionBox" ref={proofRef} style={{ display: formData[applicantCitizenStatus] !== 'US Citizen or US National' && formData[applicantCitizenStatus] !== 'Other' ? 'flex' : 'none'}}>
                <div className="QuestionLabel">Please check all forms of proof you can provide:</div>
                <div className="ProofBoxes">
                    <div>
                        <input type='checkbox' id='proof_01' name='proof_01' value='proof_01' checked={formData[applicantCitizenStatusProofId].includes('proof_01')} onChange={handleProof}/>
                        <label htmlFor='proof_01'>{proof[0].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_02' name='proof_02' value='proof_02' checked={formData[applicantCitizenStatusProofId].includes('proof_02')} onChange={handleProof}/>
                        <label htmlFor='proof_02'>{proof[1].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_03' name='proof_03' value='proof_03' checked={formData[applicantCitizenStatusProofId].includes('proof_03')} onChange={handleProof}/>
                        <label htmlFor='proof_03'>{proof[2].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_04' name='proof_04' value='proof_04' checked={formData[applicantCitizenStatusProofId].includes('proof_04')} onChange={handleProof}/>
                        <label htmlFor='proof_04'>{proof[3].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_05' name='proof_05' value='proof_05' checked={formData[applicantCitizenStatusProofId].includes('proof_05')} onChange={handleProof}/>
                        <label htmlFor='proof_05'>{proof[4].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_06' name='proof_06' value='proof_06' checked={formData[applicantCitizenStatusProofId].includes('proof_06')} onChange={handleProof}/>
                        <label htmlFor='proof_06'>{proof[5].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_07' name='proof_07' value='proof_07' checked={formData[applicantCitizenStatusProofId].includes('proof_07')} onChange={handleProof}/>
                        <label htmlFor='proof_07'>{proof[6].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_08' name='proof_08' value='proof_08' checked={formData[applicantCitizenStatusProofId].includes('proof_08')} onChange={handleProof}/>
                        <label htmlFor='proof_08'>{proof[7].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_09' name='proof_09' value='proof_09' checked={formData[applicantCitizenStatusProofId].includes('proof_09')} onChange={handleProof}/>
                        <label htmlFor='proof_09'>{proof[8].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_10' name='proof_10' value='proof_10' checked={formData[applicantCitizenStatusProofId].includes('proof_10')} onChange={handleProof}/>
                        <label htmlFor='proof_10'>{proof[9].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_11' name='proof_11' value='proof_11' checked={formData[applicantCitizenStatusProofId].includes('proof_11')} onChange={handleProof}/>
                        <label htmlFor='proof_11'>{proof[10].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_12' name='proof_12' value='proof_12' checked={formData[applicantCitizenStatusProofId].includes('proof_12')} onChange={handleProof}/>
                        <label htmlFor='proof_12'>{proof[11].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_13' name='proof_13' value='proof_13' checked={formData[applicantCitizenStatusProofId].includes('proof_13')} onChange={handleProof}/>
                        <label htmlFor='proof_13'>{proof[12].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_14' name='proof_14' value='proof_14' checked={formData[applicantCitizenStatusProofId].includes('proof_14')} onChange={handleProof}/>
                        <label htmlFor='proof_14'>{proof[13].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_15' name='proof_15' value='proof_15' checked={formData[applicantCitizenStatusProofId].includes('proof_15')} onChange={handleProof}/>
                        <label htmlFor='proof_15'>{proof[14].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_16' name='proof_16' value='proof_16' checked={formData[applicantCitizenStatusProofId].includes('proof_16')} onChange={handleProof}/>
                        <label htmlFor='proof_16'>{proof[15].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_17' name='proof_17' value='proof_17' checked={formData[applicantCitizenStatusProofId].includes('proof_17')} onChange={handleProof}/>
                        <label htmlFor='proof_17'>{proof[16].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_18' name='proof_18' value='proof_18' checked={formData[applicantCitizenStatusProofId].includes('proof_18')} onChange={handleProof}/>
                        <label htmlFor='proof_18'>{proof[17].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_19' name='proof_19' value='proof_19' checked={formData[applicantCitizenStatusProofId].includes('proof_19')} onChange={handleProof}/>
                        <label htmlFor='proof_19'>{proof[18].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_20' name='proof_20' value='proof_20' checked={formData[applicantCitizenStatusProofId].includes('proof_20')} onChange={handleProof}/>
                        <label htmlFor='proof_20'>{proof[19].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_21' name='proof_21' value='proof_21' checked={formData[applicantCitizenStatusProofId].includes('proof_21')} onChange={handleProof}/>
                        <label htmlFor='proof_21'>{proof[20].value}</label>
                    </div>
                    <div>
                        <input type='checkbox' id='proof_22' name='proof_22' value='proof_22' checked={formData[applicantCitizenStatusProofId].includes('proof_22')} onChange={handleProof}/>
                        <label htmlFor='proof_22'>{proof[21].value}</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Citizenship;